module.exports = __webpack_public_path__ + "static/media/linux.584fe0e1.svg";